import { SxProps, Theme } from '@mui/material';

export const hideNumberFieldStyle: SxProps<Theme> = {
    '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
        display: 'none',
    },
    '& input[type=number]': {
        MozAppearance: 'textfield',
    },
};
